module.exports = __webpack_public_path__ + "img/login_picture.626a4065.png";